module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "node-body"
  }, [(_vm.nodeType === 'article') ? _c('article-body', {
    attrs: {
      "nid": _vm.nid
    }
  }) : (_vm.nodeType === 'person') ? _c('person-body', {
    attrs: {
      "nid": _vm.nid
    }
  }) : _c('comparison-body', {
    attrs: {
      "nid": _vm.nid
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9633be58","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/NodeBody.vue
// module id = 1772
// module chunks = 1